import React from 'react';
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';

import {Input, CardContainer, Notification, Select, Button, Validator, Editor} from 'components/common/uiKit';

import * as RouteService from 'services/route'
import {serverUrl} from 'services/network';
import {LessonApi} from 'services/network/api';
import {convertDigitsToStandard} from 'services/converts/numbers';
import {getSettings} from 'services/setting';


import NoImage from 'assets/images/NoImage.jpg';

class LessonDetail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            type: '',
            id: 0,
            lessonId: 0,
            contentTypes: [],
            uploadedFiles: [],
            imagePreview: '',
            submitLoading: false,

            contentType: 1,
            content: '',
            order: 0
        };

        this.validator = Validator(props.locale.abbreviation);

    }

    componentDidMount() {
        this.getParams();
        this.loadContentTypesData();
    }

    getParams() {
        let id = 0, type = '', lessonId = 0;

        const qs = RouteService.QueryStringService.getQyeryStrings();

        if (!qs || !qs.type || (qs.type.toLowerCase() == 'edit' && !qs.id) || (qs.type.toLowerCase() == 'add' && !qs.lessonId)) {
            Notification('error', 'WrongParams');
            const {history} = this.props;
            history.goBack();
        }

        type = qs.type;
        id = qs.type.toLowerCase() == 'edit' ? qs.id : 0;
        lessonId = qs.type.toLowerCase() == 'add' ? qs.lessonId : 0;

        this.setState({type, id, lessonId}, () => {
            this.loadData();
        });
    }

    loadData() {
        const {type, id} = this.state;
        if (type.toLowerCase() == 'edit') {
            LessonApi.GetAdminDetail(id)
                .then(res => {
                    if (res && res.status == 200) {
                        const {data} = res;
                        this.setState({
                            contentType: data.type,
                            content: data.content,
                            order: data.order
                        });
                    }
                });
        }
    }

    loadContentTypesData() {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Components.Select.ContentTypes;

        LessonApi.GetContentTypes()
            .then(res => {
                if (res && res.status == 200) {
                    let {data} = res;
                    data = data.map(x => {
                        const item = {
                            id: x.id,
                            name: pageTranslates[x.name]
                        };
                        return item;
                    });
                    this.setState({contentTypes: data});
                }
            })
    }

    handleContentTypeOnChange = event => {
        const value = event.target.value;
        this.setState({contentType: value, content: '', uploadedFiles: [], imagePreview: ''});
    };

    handleImageUpload = (evt) => {
        const setting = getSettings();
        if (!setting)
            Notification('error', 'UnknownException');

        const file = evt.target.files;
        if (file[0].size <= setting.image.maxSize) {
            this.setState({uploadedFiles: file});

            const reader = new FileReader();
            const url = reader.readAsDataURL(file[0]);
            reader.onloadend = function (e) {
                this.setState({
                    imagePreview: [reader.result]
                })
            }.bind(this);
        } else {
            this.setState({uploadedFiles: []});
            Notification('error', 'HugeFile');
        }
    };

    handleVideoUpload = (evt) => {
        const setting = getSettings();
        if (!setting)
            Notification('error', 'UnknownException');

        const file = evt.target.files;
        if (file[0].size <= setting.video.maxSize) {
            this.setState({uploadedFiles: file})
        } else {
            this.setState({uploadedFiles: []});
            Notification('error', 'HugeFile');
        }
    };

    handleContent = () => {
        const {contentType, content, uploadedFiles} = this.state;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Lesson.Detail;
        const contentTypeTranslates = locale.translation.Components.Select.ContentTypes;

        switch (parseInt(contentType)) {
            case 1: //text
                return (
                    <div className='mt-3'>
                        <Input label={pageTranslates.Content} type='text-area' value={content}
                               onChange={this.handleInputChange('content')}/>
                        {this.validator.message(contentTypeTranslates.Text, content, 'required')}
                    </div>
                );
            case 2: //Image
                const {imagePreview} = this.state;
                let imageUrl = NoImage;
                if (content && !imagePreview)
                    imageUrl = `${serverUrl}${content.split('\\').join('/')}`;
                if (imagePreview) {
                    imageUrl = imagePreview;
                }
                return (
                    <div className='mb-3'>
                        <div onClick={() => global.document.getElementById('browseImageFileButton').click()}
                             style={{position: 'relative'}}>
                            {this.validator.message(contentTypeTranslates.Image, uploadedFiles, 'required')}

                            <div style={{
                                position: 'absolute',
                                display: 'flex',
                                flex: 1,
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                width: '100%',
                                height: '100%',
                                borderRadius: 15
                            }}>
                                <i className='fa fa-upload font-40 text-white'/>
                            </div>
                            <img src={imageUrl} className="preload-img img-fluid bottom-20 w-100"
                                 style={{borderRadius: 15}}/>
                            <input
                                id="browseImageFileButton"
                                type="file"
                                accept="image/*"
                                onChange={this.handleImageUpload}
                                hidden
                            />

                        </div>
                    </div>
                );
            case 3: //Video
                let size = 0;
                if (uploadedFiles && uploadedFiles.length > 0) {
                    size = uploadedFiles[0].size;
                    const i = Math.floor(Math.log(size) / Math.log(1024));
                    size = (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
                }

                return (
                    <div className='text-center'>
                        {this.validator.message(contentTypeTranslates.Video, uploadedFiles, 'required')}

                        <input
                            id="browseVideoFileButton"
                            type="file"
                            //accept="video/mov, video/3g2, video/3gp, video/3gp2, video/3gpp, video/asf, video/asx, video/avi, video/divx, video/m4v,  video/mp4, video/mpe, video/x-m4v, video/mpeg, video/mpg, video/ogg, video/wmv"
                            accept="video/*"
                            onChange={this.handleVideoUpload}
                            hidden
                        />
                        {size ?
                            <div className='text-center'>
                                <p className='text-center color-primary mb-0'>
                                    {pageTranslates.DetectedFile}
                                </p>
                                <span className='color-secondary'>
                                    {pageTranslates.FileSize}: {size}
                            </span>
                            </div> : ''
                        }
                        <Button type='warning'
                                onClick={() => global.document.getElementById('browseVideoFileButton').click()}>
                            <i className='fa fa-upload font-14 ml-3'/>
                            {pageTranslates.UploadVideo}
                        </Button>
                    </div>
                );
            case 4: // Editor
                return (
                    <div className='mt-3'>
                        <Editor label={pageTranslates.Content} value={content} onChange={this.handleEditorOnChange}/>
                        {this.validator.message(contentTypeTranslates.Text, content, 'required')}
                    </div>
                );
        }
    };

    handleInputChange = name => event => {
        this.setState({[name]: convertDigitsToStandard(event.target.value)});
    };

    handleEditorOnChange = val => {
        this.setState({content: val});
    };

    handleSubmitOnClick = () => {
        const {contentType, content} = this.state;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Components.Select.ContentTypes;

        const formValidateResult =
            (contentType == "1" && this.validator.fieldValid(pageTranslates.Text)) || (contentType == "1" && this.validator.fieldValid(pageTranslates.Text))
            || (contentType == "2" && this.validator.fieldValid(pageTranslates.Image) || content)
            || (contentType == "3" && this.validator.fieldValid(pageTranslates.Video) || content);

        if (formValidateResult) {
            const {type, id, lessonId, uploadedFiles, contentType, order} = this.state;
            const {history} = this.props;
            this.setState({submitLoading: true});

            switch (type.toLowerCase()) {
                case 'add':
                    const createForm = new FormData();
                    createForm.append('file', uploadedFiles[0]);
                    createForm.append('lessonId', lessonId);
                    createForm.append('content', content);
                    createForm.append('type', contentType);
                    createForm.append('order', order);

                    LessonApi.CreateDetail(createForm)
                        .then(res => {
                            if (res && res.status == 200) {
                                Notification('success', 'Succeed');
                                const {data} = res;

                                const {history} = this.props;
                                history.replace({
                                    pathname: `lessonDetail?type=edit&id=${data.id}`
                                });
                            }
                        }).finally(() => {
                        this.setState({submitLoading: false});
                    });

                    break;
                case 'edit':
                    const editForm = new FormData();
                    editForm.append('file', uploadedFiles[0]);
                    editForm.append('id', id);
                    editForm.append('content', content);
                    editForm.append('type', contentType);
                    editForm.append('order', order);

                    LessonApi.UpdateDetail(editForm)
                        .then(res => {
                            if (res && res.status == 200) {
                                Notification('success', 'Succeed');
                                const {data} = res;
                                this.loadData()
                            }
                        }).finally(() => {
                        this.setState({submitLoading: false});
                    });

                    break;
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
            Notification('error', 'WrongData');
            this.setState({btnLoading: false});
        }
    };

    handleCancelOnClick = () => {
        const {history} = this.props;
        history.goBack();
    };

    render() {
        const {contentTypes, contentType, content, order, submitLoading} = this.state;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Lesson.Detail;

        return (
            <CardContainer>
                <div>
                    <Input label={pageTranslates.Priority} placeHolder={pageTranslates.Priority} value={order}
                           onChange={this.handleInputChange('order')}/>
                </div>
                <div className='mt-2'>
                    <label className='mb-0 color-primary font-13 text-right w-100'>{pageTranslates.ContentType}</label>
                    <Select data={contentTypes} value={contentType} onChange={this.handleContentTypeOnChange}/>
                </div>
                {this.handleContent()}
                <div className='mt-3'>
                    <Button full type='primary' onClick={this.handleSubmitOnClick} loading={submitLoading}>
                        {pageTranslates.Submit}
                    </Button>
                    <Button full type='secondary' onClick={this.handleCancelOnClick}>
                        {pageTranslates.Cancel}
                    </Button>
                </div>
            </CardContainer>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(LessonDetail));
